import classnames from "classnames";
import withTouchOutsideDismissible from "../../common/WithTouchOutsideDismissible";
import WarningBanner from "../WarningBanner";
import styles from "./index.css";

const className = classnames(styles.warningBanner, styles.show);

export default withTouchOutsideDismissible({
  component: WarningBanner,
  className,
  shouldRenderKey: "warningMessage"
});
